import React from 'react'

import Base from '../_Base'

const Report = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M4.764 2.076a1 1 0 0 1 .993.883l.007.117.002.621c1.017.24 1.854.358 2.505.358.805 0 1.782-.182 2.909-.548 2.67-.922 4.615-1.278 5.927-1.03 1.105.208 1.952.46 2.561.772.36.185.6.537.644.934l.008.133v9.32a1.1 1.1 0 0 1-1.68.938c-.58-.36-1.148-.532-1.718-.532-1.687 0-3.376.31-5.093.94-1.077.367-2.245.585-3.503.654a7.527 7.527 0 0 1-2.562-.312v5.58a1 1 0 0 1-1.994.117l-.006-.117V3.076a1 1 0 0 1 1-1zm7.051 3.327c-1.329.432-2.508.652-3.544.652-.71 0-1.543-.103-2.506-.308v7.464c.844.332 1.66.472 2.45.429 1.08-.06 2.07-.244 2.947-.544 1.913-.702 3.834-1.054 5.76-1.054.382 0 .76.045 1.133.134l.264.071V4.843a9.954 9.954 0 0 0-1.31-.348l-.273-.053c-.875-.166-2.54.14-4.92.961z"
      fillRule="evenodd"
    />
  </Base>
)

export default Report
